import React, { memo } from "react";

import { EworkitGroup, IGroupProps } from "./EworkitGroup";

import "./_group.scss";

interface Props extends IGroupProps {}

export const Group: React.FC<Props> = memo(props => {
  return (
    <div className="group">
      <EworkitGroup {...props} />
    </div>
  );
});
